import React, { useContext, useState, useEffect } from 'react'
import { LanguageContext } from '../Language/LanguageContext'
import { NotifyContext } from '../Library/Notify'
import { Form, Row, Col, Button } from 'react-bootstrap'
import DatePicker from "react-datepicker";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGlobeAsia, faUsers } from '@fortawesome/free-solid-svg-icons'
import { Checkbox, HeaderTitle } from '../Library'
import { createCalendar, addDepartmentEvent } from '../Network/Calendar'
import { listCompany } from '../Network/Company'
import { listDepartment } from '../Network/Department'
import { useHistory } from 'react-router-dom'
import dayjs from 'dayjs'
import "./AddCalendar.css"
import MultiSelect from "react-multi-select-component";
import { setDocumentTitle } from "../AppTitle"
import { RoleContext } from "../Role/RoleContext"

function AddCalendar() {
    const history = useHistory()
    const role = useContext(RoleContext)
    const prefixAuthority = "NEWS_"
    const globalAuthority = "SET_GLOBAL"
    const companyAuthority = "SET_COMPANY"
    const langCx = useContext(LanguageContext)
    const notify = useContext(NotifyContext)
    const lang = langCx.lang.calendar
    const [title, setTitle] = useState("")
    const [description, setDescription] = useState("")
    const [location, setLocation] = useState("")
    const [startDate, setStartDate] = useState(new Date())
    const [endDate, setEndDate] = useState(new Date())
    const [isAllday, setAllday] = useState(false)
    const [isHoliday, setHoliday] = useState(false)
    const [isYearly, setYearly] = useState(false)
    const [publication, setPublication] = useState(0)
    const [isError, setError] = useState(false)
    const [companyList, setCompany] = useState([])
    const [selectedCompany, setSelectedCompany] = useState("")
    const [departmentList, setDepartment] = useState([])
    const [selectedDepartment, setSelectedDepartment] = useState([])

    const fetchCompany = () =>{
        listCompany(
            (data)=>{
                setCompany(data)
            },
            (error)=>{

            }
        )
    }

    const fetchDepartment = (companyId) =>{
        listDepartment(companyId,
            (data)=>{
                var list = []
                data.foreach((item)=>{
                    list.push({ label: item.name, value: item.id })
                })
                setDepartment(list)
            },
            (error)=>{

            })
    }

    const addDepartment = (eventId) =>{
        selectedDepartment.forEach((item)=>{
            addDepartmentEvent(eventId, item.value,
                ()=>{ },
                (error)=>{
                    
                })
        })
    }

    const submit = () =>{
        let isGlobal = publication === 0 ? true:false 
        let type = isHoliday ? "HOLIDAY": "NORMAL"
        let start = dayjs(startDate).valueOf()
        let end = dayjs(endDate).valueOf()

        if(!title || !description || !location){
            notify.showNotify(lang.not_complete, lang.not_complete_desc, 1)
            setError(true)
            return;
        }else if((start > end) && !isAllday){
            notify.showNotify(lang.start_greater_than, lang.start_greater_than_desc, 1)
            setError(true)
            return;
        }

        createCalendar(title, description, start, end, location, type, isGlobal, isAllday, isYearly,
            (data)=>{
                addDepartment(data.id)
                notify.showNotify(lang.add_success, lang.add_success_desc, 0)
                history.push("/calendar")
            },
            (error)=>{
                notify.showNotify("Something wrong submit", error.message, 2)
            })
    }

    const switchPublication = (publication) =>{
        if(publication === 1){
            fetchCompany()
        }
        setPublication(publication)
    }

    useEffect(()=>{
        setDocumentTitle("Add Calendar")
        if(!role.checkPermission(prefixAuthority, companyAuthority)){
            fetchCompany()
            let companyId = parseInt(localStorage.getItem("company_id"))
            setSelectedCompany(companyId)
            fetchDepartment(companyId)
            setPublication(1)
        }else if(!role.checkPermission(prefixAuthority, globalAuthority)){
            fetchCompany()
            setPublication(1)
        }
    },[role])
   
    return (
        <div id="add-calendar">
            <HeaderTitle title={lang.create_event} isShowBack backTo="/calendar"/>
            <div className="content-container">
                <Row>
                    <Col md={10} lg={8} xl={6}>
                        <Form
                        onSubmit={(e)=>{
                            e.preventDefault()
                            submit()
                        }}>
                            <Form.Group>
                                <Form.Label>{lang.title}</Form.Label>
                                <Form.Control
                                value={title}
                                onChange={(e)=>setTitle(e.target.value)}
                                isInvalid={isError && !title}
                                />
                            </Form.Group>
                            <Form.Group>
                                <Form.Label>{lang.description}</Form.Label>
                                <Form.Control as="textarea"
                                value={description}
                                onChange={(e)=>setDescription(e.target.value)}
                                isInvalid={isError && !description}
                                />
                            </Form.Group>
                            <Form.Group>
                                <Form.Label>{lang.location}</Form.Label>
                                <Form.Control
                                value={location}
                                onChange={(e)=>setLocation(e.target.value)}
                                isInvalid={isError && !location}
                                />
                            </Form.Group>
                            <hr/>
                            <Form.Group>
                                { role.checkPermission(prefixAuthority, globalAuthority) ?
                                <>
                                <Form.Label>{lang.publication}</Form.Label>
                                <div style={{display: "flex"}}>
                                    <PublishItem
                                    title={lang.public}
                                    icon={faGlobeAsia}
                                    isSelected={publication === 0 ? true:false}
                                    onClick={()=>switchPublication(0)}/>
                                    <PublishItem
                                    title={lang.department}
                                    icon={faUsers}
                                    isSelected={publication === 1 ? true:false}
                                    onClick={()=>switchPublication(1)}/>
                                </div>
                                </>
                                : null
                                }
                                { publication === 1 ?
                                <div style={{marginTop: 10}}>
                                    <Form.Group>
                                        <Form.Label>{lang.company}</Form.Label>
                                        <Form.Control as="select"
                                        value={selectedCompany}
                                        disabled={!role.checkPermission(prefixAuthority, companyAuthority) ? true:false}
                                        onChange={(e)=>{
                                            let id = e.target.value
                                            setSelectedCompany(id)
                                            setDepartment([])
                                            setSelectedDepartment([])
                                            fetchDepartment(id)
                                        }}>
                                            <option value="">{lang.choose_company}</option>
                                            { companyList.map((item, key)=>
                                            <option key={key} value={item.id}>{item.name}</option>
                                            )}
                                        </Form.Control>
                                    </Form.Group>
                                    <Form.Group>
                                        <Form.Label>{lang.department}</Form.Label>
                                        <MultiSelect
                                        disabled={selectedCompany === "" ? true:false}
                                        options={departmentList}
                                        value={selectedDepartment}
                                        onChange={setSelectedDepartment}
                                        />
                                    </Form.Group>
                                </div>
                                : null
                                }
                            </Form.Group>
                            <hr/>
                            <Form.Group>
                                <Form.Label>{lang.start_date}</Form.Label>
                                <DatePicker 
                                selected={startDate}
                                onChange={(date)=>{
                                    setStartDate(date)
                                    if(isAllday){
                                        setEndDate(date)
                                    }
                                }}
                                className="form-control" 
                                dateFormat="d MMMM yyyy - H:mm"
                                showTimeSelect/>
                            </Form.Group>
                            <Form.Group>
                                <Form.Label>{lang.end_date}</Form.Label>
                                <DatePicker 
                                selected={endDate}
                                onChange={(date)=>setEndDate(date)}
                                className="form-control" 
                                dateFormat="d MMMM yyyy - H:mm"
                                disabled={isAllday}
                                showTimeSelect/>
                            </Form.Group>
                            <hr/>
                            <Form.Group>
                                <Checkbox
                                label={lang.all_day}
                                checked={isAllday}
                                onChange={()=>{
                                    setAllday(!isAllday ? true:false)
                                    setEndDate(startDate)
                                }}
                                />
                            </Form.Group>
                            <Form.Group>
                                <Checkbox
                                label={lang.holiday}
                                checked={isHoliday}
                                onChange={()=>setHoliday(!isHoliday ? true:false)}
                                />
                            </Form.Group>
                            <Form.Group>
                                <Checkbox
                                label={lang.repeat_yearly}
                                checked={isYearly}
                                onChange={()=>setYearly(!isYearly ? true:false)}
                                />
                            </Form.Group>
                            
                            <hr/>
                            <Button type="submit">
                                {lang.create_event}
                            </Button>
                        </Form>
                    </Col>
                </Row>
            </div>
        </div>
    )
}

function PublishItem(props){
    return(
        <div className="publish-item"
        role="button"
        tabIndex="0"
        aria-pressed="false"
        onKeyDown={(e)=>{
            if(e.key === "Enter"){
                props.onClick()
            }
        }}
        onClick={props.onClick}
        style={{
            borderColor: props.isError ? "red": "lightgray",
            color: props.isSelected ? "white" : "black",
            backgroundColor: props.isSelected ? "#0275d8": "white"
        }}
        >
            <div>
                <div className="icon">
                    <FontAwesomeIcon icon={props.icon}/>
                </div>
                <div className="title">{props.title}</div>
                <div className="desc"
                style={{color: props.isSelected ? "white" : "gray"}}>
                    {props.desc}
                </div>
            </div>
        </div>
    )
}


export default AddCalendar